import React from "react";
import { Box } from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import AppCard from "./AppCard";

/**
 * Skeleton for a content card: title line + a few body rows.
 */
export const CardSkeleton = ({ rows = 3 }) => (
  <AppCard>
    <Box p={3}>
      <Skeleton variant="text" width="45%" height={32} />
      {Array.from({ length: rows }).map((_, i) => (
        <Skeleton key={i} variant="text" height={24} />
      ))}
    </Box>
  </AppCard>
);

/**
 * Skeleton for a data table: header bar + row lines.
 */
export const TableSkeleton = ({ rows = 6 }) => (
  <AppCard>
    <Box p={3}>
      <Skeleton variant="rect" height={40} />
      {Array.from({ length: rows }).map((_, i) => (
        <Box key={i} mt={1}>
          <Skeleton variant="text" height={28} />
        </Box>
      ))}
    </Box>
  </AppCard>
);

/**
 * Skeleton matching the StatCard row shape.
 */
export const StatSkeleton = ({ count = 4 }) => (
  <Box display="flex" flexDirection="column" gridGap={14}>
    {Array.from({ length: count }).map((_, i) => (
      <Skeleton key={i} variant="rect" height={68} style={{ borderRadius: 12 }} />
    ))}
  </Box>
);
